export const cardBrands = {
    MasterCard: 'mc',
    Visa: 'visa',
    Amex: 'amex',
    Maestro: 'maestro',
    Diners: 'diners',
    JCB: 'jcb',
    Discover: 'discover',
    Cartebancaire: 'cartebancaire',
};
